import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastService } from 'src/app/shared/service/toast.service';

export function handleApiError(toastService: ToastService, fallback: string) {
  return catchError((err) => {
    const mensajes = err?.error?.listMessage?.length
      ? err.error.listMessage
      : [fallback];
    toastService.showMessages('error', mensajes);
    return throwError(() => err);
  });
}
